module.exports = __webpack_public_path__ + "img/3.9888f0cf.jpg";